import { getAllPostSlugs } from '../components/lib/wp';
import Head from 'next/head';
import SiteLayout from "../components/layout/SiteLayout";
import PageLayout from "../components/page/PageLayout";

function Page({ post, global }) {
	
	if (!post) return null;
					
	return (

		<>
			<Head>
				{post.page_title &&
					<title>{ post.page_title }</title>
				}
				{!post.page_title &&
					<title>Dobre</title>
				}
				{post.page_description &&
					<meta name="description" content={post.page_description} />
				}
				{post.canonical_url &&
					<link href={post.canonical_url} rel="canonical" />
				}
				{post.social_image &&
					<meta property="og:image" content={post.social_image} />
				}
				<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, interactive-widget=resizes-content" />
				<link rel="apple-touch-icon" sizes="57x57" href={`${process.env.NEXT_PUBLIC_SITE_URL}/icons/apple-icon-57x57.png`} />
				<link rel="apple-touch-icon" sizes="60x60" href={`${process.env.NEXT_PUBLIC_SITE_URL}/icons/apple-icon-60x60.png`} />
				<link rel="apple-touch-icon" sizes="72x72" href={`${process.env.NEXT_PUBLIC_SITE_URL}/icons/apple-icon-72x72.png`} />
				<link rel="apple-touch-icon" sizes="76x76" href={`${process.env.NEXT_PUBLIC_SITE_URL}/icons/apple-icon-76x76.png`} />
				<link rel="apple-touch-icon" sizes="114x114" href={`${process.env.NEXT_PUBLIC_SITE_URL}/icons/apple-icon-114x114.png`} />
				<link rel="apple-touch-icon" sizes="120x120" href={`${process.env.NEXT_PUBLIC_SITE_URL}/icons/apple-icon-120x120.png`} />
				<link rel="apple-touch-icon" sizes="144x144" href={`${process.env.NEXT_PUBLIC_SITE_URL}/icons/apple-icon-144x144.png`} />
				<link rel="apple-touch-icon" sizes="152x152" href={`${process.env.NEXT_PUBLIC_SITE_URL}/icons/apple-icon-152x152.png`} />
				<link rel="apple-touch-icon" sizes="180x180" href={`${process.env.NEXT_PUBLIC_SITE_URL}/icons/apple-icon-180x180.png`} />
				<link rel="icon" type="image/png" sizes="192x192"  href={`${process.env.NEXT_PUBLIC_SITE_URL}/icons/android-icon-192x192.png`} />
				<link rel="icon" type="image/png" sizes="32x32" href={`${process.env.NEXT_PUBLIC_SITE_URL}/icons/favicon-32x32.png`} />
				<link rel="icon" type="image/png" sizes="96x96" href={`${process.env.NEXT_PUBLIC_SITE_URL}/icons/favicon-96x96.png`} />
				<link rel="icon" type="image/png" sizes="16x16" href={`${process.env.NEXT_PUBLIC_SITE_URL}/icons/favicon-16x16.png`} />
				<link rel="manifest" href={`${process.env.NEXT_PUBLIC_SITE_URL}/icons/manifest.json`} />
				<meta name="msapplication-TileColor" content="#ffffff" />
				<meta name="msapplication-TileImage" content={`${process.env.NEXT_PUBLIC_SITE_URL}/icons/ms-icon-144x144.png`} />
				<meta name="theme-color" content="#ffffff" />
			</Head>
			
			<SiteLayout global={global}>
				<PageLayout post={post} />
			</SiteLayout>		
		</>	
			
	)
	
}

export async function getStaticProps({ params }) {
	const slug = params.slug;

	try {
		const dataRes = await fetch(
			`${process.env.NEXT_PUBLIC_WORDPRESS_CUSTOM_API_URL}/page/${slug}?v=${Math.floor(Math.random() * 999999)}`
		);
		const data = await dataRes.json();
		const post = data && Object.keys(data).length !== 0 ? data : null;

		if (!post) {
			return { notFound: true };
		}

		const globalRes = await fetch(
			`${process.env.NEXT_PUBLIC_WORDPRESS_CUSTOM_API_URL}/global?v=${Math.floor(Math.random() * 999999)}`
		);
		const globalData = await globalRes.json();
		const global = globalData && Object.keys(globalData).length !== 0 ? globalData : null;

		return {
				props: {
				post,
				global,
			},
			revalidate: 60,
		};
	} catch (err) {
		return { notFound: true };
	}
}

export async function getStaticPaths() {
	const allPosts = await getAllPostSlugs('pages');
	const paths = allPosts.map(post => ({ params: { slug: post } }));
	return {
		paths,
		fallback: 'blocking',
	};
}

export default Page